<template>
    <div>
        <button
            class="btn btn-purple ml-2"
            @click="add"
            :disabled="!hasSelected"
        >ADD
        </button>
    </div>
</template>

<script>
  import eventBus from "../../../event-bus";

  export default {
    data() {
      return {
        current: null,
      };
    },

    computed: {
      /**
       * @return {Boolean}
       */
      hasSelected() {
        return Boolean(this.current);
      },
    },

    methods: {
      /**
       * @return {undefined}
       */
      add() {
        eventBus.$emit('show-add-send-list-conversation-item-modal-form', {
          url: _.get(this.current, 'createConversationUrl'),
        });
      },

      /**
       * @param {Object|null} item
       */
      onSendListSelected(item) {
        this.current = item;
      },
    },

    created() {
      eventBus.$on('send-list-select', this.onSendListSelected);
    },

    beforeDestroy() {
      eventBus.$off('send-list-select', this.onSendListSelected);
    },
  }
</script>
